import React from 'react';
import { Globe } from 'lucide-react';
const translations = {
  en: {
    poweredBy: 'Powered by Impresso AI',
    copyright: '© 2023 Impresso. All rights reserved.',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    contact: 'Contact Us'
  },
  de: {
    poweredBy: 'Unterstützt von Impresso AI',
    copyright: '© 2023 Impresso. Alle Rechte vorbehalten.',
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutzrichtlinie',
    contact: 'Kontaktieren Sie uns'
  },
  fr: {
    poweredBy: 'Propulsé par Impresso AI',
    copyright: '© 2023 Impresso. Tous droits réservés.',
    terms: "Conditions d'utilisation",
    privacy: 'Politique de confidentialité',
    contact: 'Contactez-nous'
  },
  it: {
    poweredBy: 'Alimentato da Impresso AI',
    copyright: '© 2023 Impresso. Tutti i diritti riservati.',
    terms: 'Termini di servizio',
    privacy: 'Informativa sulla privacy',
    contact: 'Contattaci'
  }
};
export function Footer({
  language
}) {
  const t = translations[language];
  return <footer className="bg-white border-t border-gray-200 py-6" data-id="element-312">
      <div className="container mx-auto px-4" data-id="element-313">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-314">
          <div className="flex items-center mb-4 md:mb-0" data-id="element-315">
            <div className="text-blue-600 font-bold mr-2" data-id="element-316">Impresso</div>
            <div className="text-sm text-gray-500" data-id="element-317">{t.poweredBy}</div>
          </div>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-4 md:mb-0" data-id="element-318">
            <a href="#" className="text-sm text-gray-600 hover:text-blue-600 transition-colors" data-id="element-319">
              {t.terms}
            </a>
            <a href="#" className="text-sm text-gray-600 hover:text-blue-600 transition-colors" data-id="element-320">
              {t.privacy}
            </a>
            <a href="#" className="text-sm text-gray-600 hover:text-blue-600 transition-colors" data-id="element-321">
              {t.contact}
            </a>
          </div>
          <div className="text-sm text-gray-500 flex items-center" data-id="element-322">
            <Globe size={16} className="mr-1" data-id="element-323" />
            <span data-id="element-324">{t.copyright}</span>
          </div>
        </div>
      </div>
    </footer>;
}